import { Component, OnInit, ViewChild } from '@angular/core';
import { DEFECTCLASS, INCIDENCE, DEFECTMODE, DASHBOARDSQL, MDISTRIBUTION, PDCA, DPI, FORMULAE, DASHBOARDVALUE, DASHBOARDINFO, DEFECTCLASSVALUES, DPIDEFECTCLASSSELECT, DEFECTSEVERITYSELECT, DEFECTCOST, PARETOCOLUMNS, PROCESSPARETOCOLUMNS, DASHBOARDTABS } from '../common/constants/labels';
import { IncidentUploadService } from '../incident-upload/incident-upload.service';
import * as _ from 'lodash';
import { FourmModel, PDCAModel } from '../common/models/dashboard';
import { ActivatedRoute } from '@angular/router';
import { Role } from '../common/models/role';
import { DateAdapter } from '@angular/material/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { DatePipe, formatDate } from '@angular/common';
import { DashboardSqlService } from './dashboard-sql.service';
import { IncidentsDashboardViewModel, IncidentsDashboardChartsViewModel, IncidentsDashboardParetoViewModel } from '../common/models/incident-dashboard-filterparameter';
import { ClusterFactoryData, ClusterSiteBigCategoryData } from '../common/models/ClusterFactory';
import { PivotDefectsClass, PivotDefectMode, PivotIncidence, DefectCost, PivotTableAgreement, DefectCostUI } from '../common/models/incident-dashboard-filterparameterdata';
import { ExcelService } from './excel.service';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { MatTabsModule } from '@angular/material/tabs';
import { AuthenticationService } from '../common/services/authentication.service';
import * as c3 from 'c3';
import * as d3 from 'd3';
import { DefectsCountBlockComponent } from './defects-count-block/defects-count-block.component';

@Component({
  selector: 'app-dashboard-sql',
  templateUrl: './dashboard-sql.component.html',
  styleUrls: ['./dashboard-sql.component.scss']
})
/* This is a dashboard component which loads pareto and pie charts  */
export class DashboardSqlComponent implements OnInit {
  title = 'Dashboard';
  dashboard = DASHBOARDSQL;
  role;
  cluster: string[] = [];
  showsite = true;
  site: string[] = [];
  showbigcategory = true;
  bigcategory: string[] = [];
  clusterFactoryArray: Array<ClusterFactoryData> = [];
  clustersitebigcategoryArray: Array<ClusterSiteBigCategoryData> = [];
  clusterFactory: ClusterFactoryData;
  qamatrixDashboardForm = new FormGroup({
    clusters: new FormControl(),
    sites: new FormControl(),
    bigcategories: new FormControl(),
    fromdate: new FormControl(),
    todate: new FormControl()
  });
  qamatrixDefects = new FormGroup({
    dpiDefectClassSelectControl: new FormControl(),
    defectSeveritySelectControl: new FormControl(),
    DefectModeAggregationControl: new FormControl(),
    // productcontrol: new FormControl(),
    recordidcontrol: new FormControl(),
    ProductLineControl: new FormControl(),
    PDCAStatusControl: new FormControl()
  });
  qamatrixDefectsParetoForm = new FormGroup({
    dpiDefectClassSelectControl: new FormControl(),
    defectSeveritySelectControl: new FormControl(),
    sites: new FormControl(),
    bigcategories: new FormControl(),
  });
  qamatrixParetoForm = new FormGroup({
    dpiDefectClassSelectControl: new FormControl(),
    defectSeveritySelectControl: new FormControl(),
    sites: new FormControl(),
    bigcategories: new FormControl(),
  });
  disableCluster = false;
  disableSite = false;
  defectSeveritySelectControlValue = 'ALL';
  dpiDefectClassSelectControlValue = 'ALL';
  disableDropdown = false;
  clusterdefault = [];
  sitedefault = [];
  bigcategorydefault = [];
  clustertooltip = [];
  sitetooltip = [];
  bigcategorytooltip = [];
  dataAvailable = false;
  showtabs = false;
  nofiltereddata = false;
  defectClassSelect = []; // DPIDEFECTCLASSSELECT;
  severitySelect = []; // DEFECTSEVERITYSELECT;
  defectModeAggregation: string[] = [];
  // product: string[] = [];
  recordid: string[] = [];
  productionline: string[] = [];
  pdcastatus: string[] = [];
  defectModeAggregationdefault: string[] = [];
  productdefault: string[] = [];
  recordiddefault: string[] = [];
  productlinedefault: string[] = [];
  pdcastatusdefault: string[] = [];
  showSuccess = false;
  showDashboardContent = false;
  filteredDataSource = [];
  @ViewChild('paginator', {static: false}) paginator!: MatPaginator;
  dataSource!: MatTableDataSource<any>;
  constructor(private formBuilder: FormBuilder, private dashboardService: DashboardSqlService, private uploadService: IncidentUploadService, private route: ActivatedRoute, private dateAdapter: DateAdapter<Date>, private datepipe: DatePipe, private excelService: ExcelService, private authenticateService: AuthenticationService) {
    this.dateAdapter.setLocale('en-GB');
  }
  loading = true;
  fourmsData: FourmModel;
  showPieChart = false;
  showPieChartPdca = false;
  pdcaData: PDCAModel;
  showValidationMessage = false;
  ValidationMsg = 'Please select From Date, To Date,Cluster, Site, Big Category.';
  filterParameter: any;
  chartsFilterParameter: any;
  paretoFilterParameter: any;
  inputReadonly = true;
  defectClassArray: Array<PivotDefectsClass> = [];
  incidenceArray: Array<PivotIncidence> = [];
  defectModeArray: Array<PivotDefectMode> = [];
  defectCostArray: Array<DefectCostUI> = [];
  defectclassColumns: any;
  defectcostColumns: any;
  incidenceColumns: any;
  defectModeColumns: any;
  noDefectClass = false;
  noDefectCost = false;
  noDefectMode = false;
  noIncidence = false;
  noRecords = 'No records';
  mdistribution = MDISTRIBUTION;
  pdca = PDCA;
  minDate: Date = new Date('01/01/2015');
  maxDate: Date = new Date();
  allSelected = false;
  siteAllSelected = false;
  bigCategoryAllSelected = false;
  allDefectModeAggregationSelected = false;
  allProductSelected = false;
  allRecordIDSelected = false;
  allProductLineSelected = false;
  allPDCASelected = false;
  @ViewChild('clusterControl', { static: false }) clusterControl: MatSelect;
  @ViewChild('siteControl', { static: false }) siteControl: MatSelect;
  @ViewChild('bigCategoryControl', { static: false }) bigCategoryControl: MatSelect;

  @ViewChild('DefectModeAggregationControl', { static: false }) DefectModeAggregationControl: MatSelect;
  @ViewChild('productcontrol', { static: false }) productcontrol: MatSelect;
  @ViewChild('recordidcontrol', { static: false }) recordidcontrol: MatSelect;
  @ViewChild('ProductLineControl', { static: false }) ProductLineControl: MatSelect;
  @ViewChild('PDCAStatusControl', { static: false }) PDCAStatusControl: MatSelect;
  @ViewChild('DefectsCountBlockComponent', { static : false }) defectsCountBlockComponentRef: DefectsCountBlockComponent;
  recordInserted = 0;
  recordUpdated = 0;
  recordsinserteddetails = '';
  recordupdateddetails = '';
  agreementRemarksDisable = true;
  processParetoReportArray: any[] = [];
  paretoReportArray: any[] = [];
  processParetoCol = PROCESSPARETOCOLUMNS;
  paretoCol = PARETOCOLUMNS;
  dashboardTabs = DASHBOARDTABS;
  seletedTab = DASHBOARDTABS[0];
  showProcessPareto = false;
  showPareto = false;

  ngOnInit() {
    this.loading = true;
    this.getClusterSiteBigCategoryData();
    this.defectclassColumns = DEFECTCLASS;
    this.incidenceColumns = INCIDENCE;
    this.defectModeColumns = DEFECTMODE;
    this.defectcostColumns = DEFECTCOST;
    // this.loading = false;
    this.setDefectSeveritySelect();
    this.setDpiDefectClassSelect();
  }

  dateValidation() {
    const CurrentDate = new Date();
    const dateToCheck = new Date(this.qamatrixDashboardForm.get('todate').value);
    const dateFromCheck = new Date(this.qamatrixDashboardForm.get('fromdate').value);
    if (dateToCheck > CurrentDate || dateFromCheck > CurrentDate) {
      this.ValidationMsg = 'Selected date should not be greater than current date.';
      this.showValidationMessage = true;
      return true;
    }
    if (this.qamatrixDashboardForm.get('fromdate').value != null && this.qamatrixDashboardForm.get('todate').value != null && Date.parse(this.qamatrixDashboardForm.get('fromdate').value) > Date.parse(this.qamatrixDashboardForm.get('todate').value)) {
      this.ValidationMsg = 'From Date should be less than To Date.';
      this.showValidationMessage = true;
      this.dataAvailable = false;
      this.noRecords = '';
      this.nofiltereddata = true;
      return true;
    } else {
      this.showValidationMessage = false;
      this.showSuccess = false;
      this.dataAvailable = false;
      this.noRecords = '';
      this.nofiltereddata = true;
      return false;
    }
  }

  toggleAllSelection() {
    if (this.allSelected) {
      this.clusterControl.options.forEach((item: MatOption) => item.select());
    } else {
      this.clusterControl.options.forEach((item: MatOption) => item.deselect());
      this.clustertooltip = [];
      this.sitetooltip = [];
      this.bigcategorytooltip = [];
    }
  }

  optionClick() {
    let newStatus = true;
    this.clusterControl.options.forEach((item: MatOption) => {
      if (!item.selected) {
        newStatus = false;
      }
    });
    this.allSelected = newStatus;
  }

  toggleSiteAllSelection() {
    if (this.siteAllSelected) {
      this.siteControl.options.forEach((item: MatOption) => item.select());
    } else {
      this.siteControl.options.forEach((item: MatOption) => item.deselect());
      this.sitetooltip = [];
      this.bigcategorytooltip = [];
    }
  }

  optionsiteClick() {
    let newStatus = true;
    this.siteControl.options.forEach((item: MatOption) => {
      if (!item.selected) {
        newStatus = false;
      }
    });
    this.siteAllSelected = newStatus;
  }

  toggleBigCategoryAllSelection() {
    if (this.bigCategoryAllSelected) {
      this.bigCategoryControl.options.forEach((item: MatOption) => item.select());
    } else {
      this.bigCategoryControl.options.forEach((item: MatOption) => item.deselect());
      this.bigcategorytooltip = [];
    }
  }

  optionBigCategoryClick() {
    let newStatus = true;
    this.bigCategoryControl.options.forEach((item: MatOption) => {
      if (!item.selected) {
        newStatus = false;
      }
    });
    this.bigCategoryAllSelected = newStatus;
  }

  selectClusterSiteDropdownwithdefault() {
    this.loading = true;
    let factory = '';
    this.role = localStorage.getItem('role');
    factory = localStorage.getItem('factory');
    const tempArray: string[] = [];
    const bigArray: string[] = [];
    const clustertemp: string[] = [];
    const sitetemp: string[] = [];
    const bigcategorytemp: string[] = [];
    for (let i = 0; i < this.clustersitebigcategoryArray.length; i++) {
      const factoryname = this.clustersitebigcategoryArray[i].factoryname;
      const site  = this.clustersitebigcategoryArray[i].site;
      const bigcategory = this.clustersitebigcategoryArray[i].businessgroup;
      const clustername = this.clustersitebigcategoryArray[i].subregion;
      if (factoryname === factory || this.authenticateService.findSiteNameInFactoryName(factory, site)) {
        if (clustertemp.indexOf(clustername) === -1) {
          clustertemp.push(clustername);
        }
        if (sitetemp.indexOf(site) === -1) {
          sitetemp.push(site);
        }
        if (bigcategorytemp.indexOf(bigcategory) === -1) {
          bigcategorytemp.push(bigcategory);
        }
        this.clustersitebigcategoryArray.forEach(element => {
          if (clustername === element.subregion) {
            tempArray.push(element.site);
            // bigArray.push(element.bigcategory);
          }
        });
        this.clustersitebigcategoryArray.forEach(element => {
          if (site === element.site) {
            bigArray.push(element.businessgroup);
          }
        });
        break;
      }
    }
    /* this.clustersitebigcategoryArray.forEach(clusterfilter => {
      if (clusterfilter.factoryname === factory || this.authenticateService.findSiteNameInFactoryName(factory, clusterfilter.site)) {
        if (clustertemp.indexOf(clusterfilter.clustername) === -1) {
          clustertemp.push(clusterfilter.clustername);
        }
        if (sitetemp.indexOf(clusterfilter.site) === -1) {
          sitetemp.push(clusterfilter.site);
        }
        if (bigcategorytemp.indexOf(clusterfilter.bigcategory) === -1) {
          bigcategorytemp.push(clusterfilter.bigcategory);
        }
        this.clustersitebigcategoryArray.forEach(element => {
          if (clusterfilter.clustername === element.clustername) {
            tempArray.push(element.site);
            // bigArray.push(element.bigcategory);
          }
        });
        this.clustersitebigcategoryArray.forEach(element => {
          if (clusterfilter.site === element.site) {
            bigArray.push(element.bigcategory);
          }
        });
      }
    }); */
    this.clusterdefault = clustertemp;
    this.sitedefault = sitetemp;
    this.bigcategory = bigcategorytemp;
    if (this.clusterdefault.length === 0) {
      const clusterdata = [];
      this.loading = true;
      const clusterBasedOnRole = localStorage.getItem('clusterBasedOnRole');
      let clusterBasedOnRoleparsed = [];
      if (clusterBasedOnRole !== null && clusterBasedOnRole !== undefined) {
        clusterBasedOnRoleparsed = JSON.parse(clusterBasedOnRole);
        this.clusterdefault = clusterBasedOnRoleparsed;
        this.clustersitebigcategoryArray.forEach(element => {
          clusterBasedOnRoleparsed.forEach(x => {
            if (x === element.subregion) {
              tempArray.push(element.site);
              bigArray.push(element.businessgroup);
            }
          });
        });
        this.commonfunctionSetDefault(tempArray, bigArray);
        this.loading = false;
      } else {
        this.dashboardService.getClusterFromDFOS(this.role).subscribe((response) => {
          if (response !== null) {
            response.forEach(element => {
              clusterdata.push(element.name);
            });
            localStorage.setItem('clusterBasedOnRole', JSON.stringify(clusterdata));
            this.clusterdefault = clusterdata;
            this.clustersitebigcategoryArray.forEach(element => {
              clusterdata.forEach(x => {
                if (x === element.subregion) {
                  tempArray.push(element.site);
                  bigArray.push(element.businessgroup);
                }
              });
            });
            this.commonfunctionSetDefault(tempArray, bigArray);
          }
          this.loading = false;
        });
      }
    } else {
      this.commonfunctionSetDefault(tempArray, bigArray);
      this.loading = false;
    }
  }

  commonfunctionSetDefault(tempArray: string[], bigArray: string[]) {
    this.site = tempArray.map(item => item).filter((value, index, self) => self.indexOf(value) === index).sort();
    this.sitedefault = this.sitedefault.length > 0 ? this.sitedefault : this.site;
    this.bigcategory = bigArray.map(item => item).filter((value, index, self) => self.indexOf(value) === index).sort();
    this.bigcategorydefault = this.bigcategorydefault.length > 0 ? this.bigcategorydefault : this.bigcategory;
    // this.assignSelectionFromUploadFile(); // commented due to unused code
    this.clustertooltip = this.clusterdefault.length > 0 ? this.clusterdefault : this.cluster;
    this.sitetooltip = this.sitedefault.length > 0 ? this.sitedefault : this.site;
    this.bigcategorytooltip = this.bigcategorydefault.length > 0 ? this.bigcategorydefault : this.bigcategory;

    if (this.cluster.length <= this.clusterdefault.length) {
      this.allSelected = true;
    }

    let siteAll = false;
    if (this.site.length <= this.sitedefault.length) {
      siteAll = true;
      this.siteControl.options.forEach((item: MatOption) => {
        if (!item.selected) {
          siteAll = false;
        }
      });
      this.siteAllSelected = siteAll;
    }

    let bigCategoryAll = false;
    if (this.bigcategory.length <= this.bigcategorydefault.length) {
      bigCategoryAll = true;
      this.bigCategoryControl.options.forEach((item: MatOption) => {
        if (!item.selected) {
          bigCategoryAll = false;
        }
      });
      this.bigCategoryAllSelected = bigCategoryAll;
    }

    if (this.role === Role.qualityChampion) {
      this.disableSite = false;
      this.disableCluster = true;
    } else if (this.role === Role.globalAdmin || this.role === Role.qualityGlobalRead) {
      this.disableSite = false;
      this.disableCluster = false;
    } else {
      this.disableSite = true;
      this.disableCluster = true;
    }
  }

  assignSelectionFromUploadFile() {
    const factory = localStorage.getItem('factory');
    const site = [];
    const category = [];
    if (this.role !== Role.qualityChampion && this.role !== Role.globalAdmin) {
      this.clustersitebigcategoryArray.forEach(clusterfilter => {
        if (clusterfilter.factoryname === factory) {
          site.push(clusterfilter.site);
          category.push(clusterfilter.businessgroup);
        }
      });
    }
    if (site.length > 0) {
      this.sitedefault = site;
    }
    if (category.length > 0) {
      this.bigcategorydefault = category;
    }
    this.getClusterFromUpload();
    this.getSiteFromUpload();
    this.getBigCategoryFromUpload();
  }

  getClusterFromUpload() {
    const cluster = this.dashboardService.getCluster();
    if (cluster !== null && cluster !== undefined && cluster !== '') {
      const clusterArr = [];
      clusterArr.push(cluster);
      this.clusterdefault = clusterArr;
    }
  }

  getSiteFromUpload() {
    const site = this.dashboardService.getSite();
    if (site !== null && site !== undefined && site !== '') {
      const siteArr = [];
      siteArr.push(site);
      this.sitedefault = siteArr;
    }
  }

  getBigCategoryFromUpload() {
    const bigCategory = this.dashboardService.getBigCategory();
    if (bigCategory !== null && bigCategory !== undefined && bigCategory !== '') {
      const bigArr = [];
      bigArr.push(bigCategory);
      this.bigcategorydefault = bigArr;
    }
  }

  generateReport() {
    this.loading = true;
    this.showValidationMessage = false;
    this.showSuccess = false;
    this.showProcessPareto = false;
    this.showPareto = false;
    this.showDashboardContent = true;
    const selectedFromDate = this.datepipe.transform(this.qamatrixDashboardForm.get('fromdate').value, 'MM/dd/yyyy');
    const selectedTodate = this.datepipe.transform(this.qamatrixDashboardForm.get('todate').value, 'MM/dd/yyyy');
    const selectedcluster = this.qamatrixDashboardForm.get('clusters').value;
    const selectedsite = this.qamatrixDashboardForm.get('sites').value;
    const selectedbigcategory = this.qamatrixDashboardForm.get('bigcategories').value;
    if (selectedFromDate === null || selectedFromDate === '' || selectedTodate === null || selectedTodate === ''
      || selectedcluster === null || selectedcluster === '' || selectedcluster.length === 0
      || selectedsite === null || selectedsite === '' || selectedsite.length === 0
      || selectedbigcategory === null || selectedbigcategory === '' || selectedbigcategory.length === 0) {
      if (!this.isAuthorized) {
        this.ValidationMsg = 'Please select From Date, To Date, Business Group.';
        this.showtabs = false;
      } else {
        this.ValidationMsg = 'Please select From Date, To Date, Sub Region, Site, Business Group.';
        this.showtabs = false;
      }
      this.showValidationMessage = true;
      this.loading = false;
    } else if (this.dateValidation()) {
      this.loading = false;
      return;
    } else {
      const selecteddpidefectclass = this.defectClassSelect[0] === this.dpiDefectClassSelectControlValue ? this.defectClassSelect : [this.dpiDefectClassSelectControlValue];
      const selecteddefectseverity = this.severitySelect[0] === this.defectSeveritySelectControlValue ? this.severitySelect : [this.defectSeveritySelectControlValue];
      if (this.seletedTab === this.dashboardTabs[2]) {
        this.filterParameter = {
          fromDate: selectedFromDate,
          toDate: selectedTodate,
          bigcategory: selectedbigcategory,
          cluster: selectedcluster,
          site: selectedsite,
          dpidefectclass: selecteddpidefectclass,
          defectseverity: selecteddefectseverity
        };
        this.getProcessParetoReportData(this.filterParameter);
      } else if (this.seletedTab === this.dashboardTabs[1]) {
        this.filterParameter = {
          fromDate: selectedFromDate,
          toDate: selectedTodate,
          bigcategory: selectedbigcategory,
          cluster: selectedcluster,
          site: selectedsite,
          dpidefectclass: selecteddpidefectclass,
          defectseverity: selecteddefectseverity
        };
        this.getParetoReportData(this.filterParameter);
      } else {
        this.filterParameter = {
          fromDate: selectedFromDate,
          toDate: selectedTodate,
          bigcategory: selectedbigcategory,
          cluster: selectedcluster,
          site: selectedsite,
        };
        this.getDashboardSQLData(this.filterParameter);
      }
    }
  }

  getDashboardSQLData(filterParameter: IncidentsDashboardViewModel) {
    this.showValidationMessage = false;
    this.showSuccess = false;
    this.dashboardService.getDashboardReportData(filterParameter).subscribe((response) => {
      this.dataAvailable = true;
      if (response.incidenetDashboardPoints !== null && (response.pivotDefectsClass.length > 1
        || response.pivotDefectMode.length > 1 || response.pivotIncidence.length > 1)) {
        let defectClass = [];
        let incidence = [];
        let defectMode = [];
        let defectCost = [];
        defectClass = [];
        response.pivotDefectsClass.forEach(e => {
          let object = {};
          object = {
            dpidefectclass: e.dpidefectclass,
            count: e.count
          };
          defectClass.push(object);
        });
        const index = defectClass.findIndex(x => x.dpidefectclass === 'A');
        if (index !== 0 && index === 1) {
          const zeroArray = defectClass[0];
          const AAArray = defectClass.splice(index, 1, zeroArray);
          defectClass.splice(0, 1, AAArray[0]);
        }
        this.defectClassArray = defectClass;
        incidence = [];
        response.pivotIncidence.forEach(e => {
          let object = {};
          object = {
            leveL0: e.leveL0,
            count: e.count
          };
          incidence.push(object);
        });
        this.incidenceArray = incidence;
        defectMode = [];
        response.pivotDefectMode.forEach(e => {
          let object = {};
          object = {
            defectmodeaggregation: e.defectmodeaggregation,
            leveL0: e.leveL0,
            fourms: e.fourms,
            // product: e.product,
            recordid: e.recordid,
            productionline: e.productionline,
            defectpriorityindex: e.defectpriorityindex,
            dpidefectclass: e.dpidefectclass,
            defectseveritygrade: e.defectseveritygrade,
            pdcastatus: e.pdcastatus,
            occurances: e.occurances,
            agreement: e.agreement,
            remarks: e.remarks,
            subregion: e.subregion,
            sites: e.sites,
            businessgroup: e.businessgroup
          };
          defectMode.push(object);
        });
        this.defectModeArray = defectMode;
        defectCost = [];
        response.defectCost.forEach(e => {
          let totaldefectCost = {};
          const currencyValue = (new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(e.totaldefectcostpercategory));
          totaldefectCost = {
            categoryid: e.categoryid,
            totaldefectcostpercategory: currencyValue
          };
          defectCost.push(totaldefectCost);
        });
        this.defectCostArray = defectCost;

        this.fourmsData = {
          Man: response.incidenetDashboardPoints.man.toString(),
          Machine: response.incidenetDashboardPoints.machine.toString(),
          Method: response.incidenetDashboardPoints.method.toString(),
          Material: response.incidenetDashboardPoints.material.toString()
        };
        this.pdcaData = {
          NotStarted: response.incidenetDashboardPoints.notStarted.toString(),
          Plan: response.incidenetDashboardPoints.plan.toString(),
          Do: response.incidenetDashboardPoints.do.toString(),
          Check: response.incidenetDashboardPoints.check.toString(),
          Act: response.incidenetDashboardPoints.act.toString(),
          Done: response.incidenetDashboardPoints.done.toString()
        };
        this.showtabs = true;
        this.showPieChartPdca = true;
        this.showPieChart = true;
        if (response.pivotDefectsClass.length === 1) {
          this.noDefectClass = true;
        }
        if (response.pivotIncidence.length === 1) {
          this.noIncidence = true;
        }

        this.filterData();

        const fromDateyear = new Date(this.filterParameter.fromDate).getFullYear();
        const fromDateVal = new Date(this.filterParameter.fromDate);
        const toDateVal = new Date(this.filterParameter.toDate);
        const startDate = new Date('01/01/' + fromDateyear);
        const todayDate = new Date();
        // const Q1Validation = new Date('03/31/' + fromDateyear);
        const H1Validation = new Date('06/30/' + fromDateyear);
        // const Q3Validation = new Date('09/30/' + fromDateyear);
        const H2Validation = new Date('12/31/' + fromDateyear);
        const H1BetweenFromDate = new Date('07/01/' + fromDateyear);
        const H1BetweenToDate = new Date('12/31/' + fromDateyear);
        const H2BetweenFromDate = new Date('01/01/' + (fromDateyear + 1));
        const H2BetweenToDate = new Date('06/30/' + (fromDateyear + 1));
        if ((fromDateVal.toDateString() === startDate.toDateString() || fromDateVal.toDateString() === H1BetweenFromDate.toDateString())
        && (toDateVal.toDateString() === H1Validation.toDateString() && H1BetweenFromDate <= todayDate && H1BetweenToDate >= todayDate)
        || (toDateVal.toDateString() === H2Validation.toDateString() && H2BetweenFromDate <= todayDate && H2BetweenToDate >= todayDate)
        && this.filterParameter.cluster.length === 1 && this.filterParameter.site.length === 1 && this.filterParameter.bigcategory.length === 1) {
          this.agreementRemarksDisable = false;
        } else {
          this.agreementRemarksDisable = true;
        }
        this.dataAvailable = true;
        this.loading = false;
      } else {
        this.loading = false;
        this.ValidationMsg = 'No data available.';
        this.showValidationMessage = true;
        this.dataAvailable = false;
      }
    }, (error) => {
      this.ValidationMsg = 'Failed to get report data. Please try again after sometime.';
      this.showValidationMessage = true;
      this.loading = false;
    });
  }

  getDashboardChartsSQLData(filterParameter: IncidentsDashboardChartsViewModel) {
    this.showValidationMessage = false;
    this.showSuccess = false;
    this.dashboardService.getDashboardChartsReportData(filterParameter).subscribe((response) => {
      this.dataAvailable = true;
      if (response.incidenetDashboardPoints !== null && (response.pivotDefectsClass.length > 1
        || response.pivotIncidence.length > 1)) {
        let defectClass = [];
        let incidence = [];
        let defectCost = [];
        defectClass = [];
        response.pivotDefectsClass.forEach(e => {
          let object = {};
          object = {
            dpidefectclass: e.dpidefectclass,
            count: e.count
          };
          defectClass.push(object);
        });
        const index = defectClass.findIndex(x => x.dpidefectclass === 'A');
        if (index !== 0 && index === 1) {
          const zeroArray = defectClass[0];
          const AAArray = defectClass.splice(index, 1, zeroArray);
          defectClass.splice(0, 1, AAArray[0]);
        }
        this.defectClassArray = defectClass;
        incidence = [];
        response.pivotIncidence.forEach(e => {
          let object = {};
          object = {
            leveL0: e.leveL0,
            count: e.count
          };
          incidence.push(object);
        });
        this.incidenceArray = incidence;
        defectCost = [];
        response.defectCost.forEach(e => {
          let totaldefectCost = {};
          const currencyValue = (new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(e.totaldefectcostpercategory));
          totaldefectCost = {
            categoryid: e.categoryid,
            totaldefectcostpercategory: currencyValue
          };
          defectCost.push(totaldefectCost);
        });
        this.defectCostArray = defectCost;
        this.fourmsData = {
          Man: response.incidenetDashboardPoints.man.toString(),
          Machine: response.incidenetDashboardPoints.machine.toString(),
          Method: response.incidenetDashboardPoints.method.toString(),
          Material: response.incidenetDashboardPoints.material.toString()
        };
        this.pdcaData = {
          NotStarted: response.incidenetDashboardPoints.notStarted.toString(),
          Plan: response.incidenetDashboardPoints.plan.toString(),
          Do: response.incidenetDashboardPoints.do.toString(),
          Check: response.incidenetDashboardPoints.check.toString(),
          Act: response.incidenetDashboardPoints.act.toString(),
          Done: response.incidenetDashboardPoints.done.toString()
        };
        this.loading = false;
        this.showtabs = true;
        this.showPieChartPdca = true;
        this.showPieChart = true;
        if (response.pivotDefectsClass.length === 1) {
          this.noDefectClass = true;
        }
        if (response.pivotIncidence.length === 1) {
          this.noIncidence = true;
        }

        const fromDateyear = new Date(this.filterParameter.fromDate).getFullYear();
        const fromDateVal = new Date(this.filterParameter.fromDate);
        const toDateVal = new Date(this.filterParameter.toDate);
        const startDate = new Date('01/01/' + fromDateyear);
        const todayDate = new Date();
        // const Q1Validation = new Date('03/31/' + fromDateyear);
        const H1Validation = new Date('06/30/' + fromDateyear);
        // const Q3Validation = new Date('09/30/' + fromDateyear);
        const H2Validation = new Date('12/31/' + fromDateyear);
        const H1BetweenFromDate = new Date('07/01/' + fromDateyear);
        const H1BetweenToDate = new Date('12/31/' + fromDateyear);
        const H2BetweenFromDate = new Date('01/01/' + (fromDateyear + 1));
        const H2BetweenToDate = new Date('06/30/' + (fromDateyear + 1));

        if ((fromDateVal.toDateString() === startDate.toDateString() || fromDateVal.toDateString() === H1BetweenFromDate.toDateString())
        && (toDateVal.toDateString() === H1Validation.toDateString() && H1BetweenFromDate <= todayDate && H1BetweenToDate >= todayDate)
        || (toDateVal.toDateString() === H2Validation.toDateString() && H2BetweenFromDate <= todayDate && H2BetweenToDate >= todayDate)
        && this.filterParameter.cluster.length === 1 && this.filterParameter.site.length === 1 && this.filterParameter.bigcategory.length === 1) {
          this.agreementRemarksDisable = false;
        } else {
          this.agreementRemarksDisable = true;
        }

      } else {
        this.loading = false;
        this.ValidationMsg = 'No data available.';
        this.showValidationMessage = true;
        this.dataAvailable = false;
      }
    }, (error) => {
      this.ValidationMsg = 'Failed to get report data. Please try again after sometime.';
      this.showValidationMessage = true;
      this.loading = false;
    });
  }

  setDpiDefectClassSelect() {
    this.defectClassSelect = [];
    let i = 1;
    this.defectClassSelect[0] = 'ALL';
    DPIDEFECTCLASSSELECT.forEach(item => {
      this.defectClassSelect[i] = item;
      i++;
    });
    this.qamatrixDefectsParetoForm.controls['dpiDefectClassSelectControl'].setValue(this.defectClassSelect[0]);
    this.qamatrixParetoForm.controls['dpiDefectClassSelectControl'].setValue(this.defectClassSelect[0]);
    this.qamatrixDefects.controls['dpiDefectClassSelectControl'].setValue(this.defectClassSelect[0]);
  }

  setDefectSeveritySelect() {
    this.severitySelect = [];
    let i = 1;
    this.severitySelect[0] = 'ALL';
    DEFECTSEVERITYSELECT.forEach(item => {
      this.severitySelect[i] = item;
      i++;
    });
    this.qamatrixDefectsParetoForm.controls['defectSeveritySelectControl'].setValue(this.severitySelect[0]);
    this.qamatrixParetoForm.controls['defectSeveritySelectControl'].setValue(this.severitySelect[0]);
    this.qamatrixDefects.controls['defectSeveritySelectControl'].setValue(this.severitySelect[0]);
  }

  changeDefectClass() {
    if (this.seletedTab === this.dashboardTabs[0]) {
      this.dpiDefectClassSelectControlValue = this.qamatrixDefects.get('dpiDefectClassSelectControl').value;
      this.filterData();
      this.filterDataForCharts();
    } else if (this.seletedTab === this.dashboardTabs[1]) {
      this.dpiDefectClassSelectControlValue = this.qamatrixDefectsParetoForm.get('dpiDefectClassSelectControl').value;
      this.filterDataForPareto();
    } else {
      this.dpiDefectClassSelectControlValue = this.qamatrixParetoForm.get('dpiDefectClassSelectControl').value;
      this.filterDataForPareto();
    }
  }

  changeDefectSeverity() {
    if (this.seletedTab === this.dashboardTabs[0]) {
      this.defectSeveritySelectControlValue = this.qamatrixDefects.get('defectSeveritySelectControl').value;
      this.filterData();
      this.filterDataForCharts();
    } else if (this.seletedTab === this.dashboardTabs[1]) {
      this.defectSeveritySelectControlValue = this.qamatrixDefectsParetoForm.get('defectSeveritySelectControl').value;
      this.filterDataForPareto();
    } else {
      this.defectSeveritySelectControlValue = this.qamatrixParetoForm.get('defectSeveritySelectControl').value;
      this.filterDataForPareto();
    }
  }

  filterDatabyConditionchange() {
    const selecteddefectModeAggregation = this.qamatrixDefects.get('DefectModeAggregationControl').value;
    // const selectedproduct = this.qamatrixDefects.get('productcontrol').value;
    const selectedrecordid = this.qamatrixDefects.get('recordidcontrol').value;
    const selectedproductline = this.qamatrixDefects.get('ProductLineControl').value;
    const selectedPDCAStatus = this.qamatrixDefects.get('PDCAStatusControl').value;
    const filterbyProduct: Array<PivotDefectMode> = [];
    const filterbyproductline: Array<PivotDefectMode> = [];
    const filterbydefectmodeAggregation: Array<PivotDefectMode> = [];
    const filterbyPDCAstatus: Array<PivotDefectMode> = [];

    if (this.defectModeArray != null && this.defectModeArray.length > 0) {
      // this.filteredDataSource = this.defectModeArray.filter(x => x.dpidefectclass === this.dpiDefectClassSelectControlValue && x.defectseveritygrade === this.defectSeveritySelectControlValue);
      if (this.defectClassSelect[0] === this.dpiDefectClassSelectControlValue
        || this.severitySelect[0] === this.defectSeveritySelectControlValue) {
          this.filteredDataSource = this.defectModeArray;
        } else {
          this.filteredDataSource = this.defectModeArray.filter(x => x.dpidefectclass === this.dpiDefectClassSelectControlValue && x.defectseveritygrade === this.defectSeveritySelectControlValue);
        }
      /* if (selectedproduct !== null && selectedproduct.length > 0) {
        this.filteredDataSource.forEach(x => {
          selectedproduct.forEach(element => {
            if (x.product === element) {
              filterbyProduct.push(x);
            }
          });
        });
        this.filteredDataSource = filterbyProduct;
      } else {
        this.filteredDataSource = [];
      } */
      if (selectedrecordid !== null && selectedrecordid.length > 0) {
        this.filteredDataSource.forEach(x => {
          selectedrecordid.forEach(element => {
            if (x.product === element) {
              filterbyProduct.push(x);
            }
          });
        });
        this.filteredDataSource = filterbyProduct;
      } else {
        this.filteredDataSource = [];
      }
      if (selectedproductline !== null && selectedproductline.length > 0) {
        this.filteredDataSource.forEach(x => {
          selectedproductline.forEach(element => {
            if (x.productionline === element) {
              filterbyproductline.push(x);
            }
          });
        });
        this.filteredDataSource = filterbyproductline;
      } else {
        this.filteredDataSource = [];
      }
      if (selecteddefectModeAggregation !== null && selecteddefectModeAggregation.length > 0) {
        this.filteredDataSource.forEach(x => {
          selecteddefectModeAggregation.forEach(element => {
            if (x.defectmodeaggregation === element) {
              filterbydefectmodeAggregation.push(x);
            }
          });
        });
        this.filteredDataSource = filterbydefectmodeAggregation;
      } else {
        this.filteredDataSource = [];
      }
      if (selectedPDCAStatus !== null && selectedPDCAStatus.length > 0) {
        this.filteredDataSource.forEach(x => {
          selectedPDCAStatus.forEach(element => {
            if (x.pdcastatus === element) {
              filterbyPDCAstatus.push(x);
            }
          });
        });
        this.filteredDataSource = filterbyPDCAstatus;
      } else {
        this.filteredDataSource = [];
      }
      if (selecteddefectModeAggregation.length === this.defectModeAggregation.length) {
        this.allDefectModeAggregationSelected = true;
      } else {
        this.allDefectModeAggregationSelected = false;
      }
      /* if (selectedproduct.length === this.product.length) {
        this.allProductSelected = true;
      } else {
        this.allProductSelected = false;
      } */
      if (selectedrecordid.length === this.recordid.length) {
        this.allRecordIDSelected = true;
      } else {
        this.allRecordIDSelected = false;
      }
      if (selectedproductline.length === this.productionline.length) {
        this.allProductLineSelected = true;
      } else {
        this.allProductLineSelected = false;
      }
      if (selectedPDCAStatus.length === this.pdcastatus.length) {
        this.allPDCASelected = true;
      } else {
        this.allPDCASelected = false;
      }
      if (this.filteredDataSource.length === 0) {
        this.nofiltereddata = true;
      } else {
        this.nofiltereddata = false;
      }
      this.dataSource = new MatTableDataSource(this.filteredDataSource);
      this.dataSource.paginator = this.paginator;
      if ((selecteddefectModeAggregation !== null && selecteddefectModeAggregation.length > 0)
        // || (selectedproduct !== null && selectedproduct.length > 0)
        || (selectedrecordid !== null && selectedrecordid.length > 0)
        || (selectedproductline !== null && selectedproductline.length > 0)
        || (selectedPDCAStatus !== null && selectedPDCAStatus.length > 0)) {
        this.filterDataForCharts();
      }
    }
  }

  toggleAllDefectModeSelection() {
    if (this.allDefectModeAggregationSelected) {
      this.DefectModeAggregationControl.options.forEach((item: MatOption) => item.select());
    } else {
      this.DefectModeAggregationControl.options.forEach((item: MatOption) => item.deselect());
    }
  }

  toggleAllProductSelection() {
    if (this.allProductSelected) {
      this.productcontrol.options.forEach((item: MatOption) => item.select());
    } else {
      this.productcontrol.options.forEach((item: MatOption) => item.deselect());
    }
  }
  toggleAllRecordIDSelection() {
    if (this.allRecordIDSelected) {
      this.recordidcontrol.options.forEach((item: MatOption) => item.select());
    } else {
      this.recordidcontrol.options.forEach((item: MatOption) => item.deselect());
    }
  }

  toggleAllProductLineSelection() {
    if (this.allProductLineSelected) {
      this.ProductLineControl.options.forEach((item: MatOption) => item.select());
    } else {
      this.ProductLineControl.options.forEach((item: MatOption) => item.deselect());
    }
  }

  toggleAllPDCASelection() {
    if (this.allPDCASelected) {
      this.PDCAStatusControl.options.forEach((item: MatOption) => item.select());
    } else {
      this.PDCAStatusControl.options.forEach((item: MatOption) => item.deselect());
    }
  }

  filterData() {
    this.showSuccess = false;
    if (this.defectModeArray != null && this.defectModeArray.length > 0) {
      if (this.defectClassSelect[0] === this.dpiDefectClassSelectControlValue
        && this.severitySelect[0] === this.defectSeveritySelectControlValue) {
          this.filteredDataSource = this.defectModeArray;
        } else if (this.defectClassSelect[0] !== this.dpiDefectClassSelectControlValue
          && this.severitySelect[0] === this.defectSeveritySelectControlValue) {
          this.filteredDataSource = this.defectModeArray.filter(x => x.dpidefectclass === this.dpiDefectClassSelectControlValue);
        } else if (this.defectClassSelect[0] === this.dpiDefectClassSelectControlValue
          && this.severitySelect[0] !== this.defectSeveritySelectControlValue) {
          this.filteredDataSource = this.defectModeArray.filter(x => x.defectseveritygrade === this.defectSeveritySelectControlValue);
        } else {
          this.filteredDataSource = this.defectModeArray.filter(x => x.dpidefectclass === this.dpiDefectClassSelectControlValue && x.defectseveritygrade === this.defectSeveritySelectControlValue);
        }
      if (this.filteredDataSource.length === 0) {
        this.nofiltereddata = true;
      } else {
        // const productArray = [];
        const recordidArray = [];
        const productlineArray = [];
        const defectModeAggregationArray = [];
        const pdcastatusArray = [];
        this.filteredDataSource.forEach(x => {
          // productArray.push(x.product);
          recordidArray.push(x.recordid);
          productlineArray.push(x.productionline);
          defectModeAggregationArray.push(x.defectmodeaggregation);
          pdcastatusArray.push(x.pdcastatus);
        });
        this.dataSource = new MatTableDataSource(this.filteredDataSource);
        this.dataSource.paginator = this.paginator;
        this.pdcastatus = pdcastatusArray.filter((n, i) => pdcastatusArray.indexOf(n) === i);
        // this.product = productArray.filter((n, i) => productArray.indexOf(n) === i);
        this.recordid = recordidArray.filter((n, i) => recordidArray.indexOf(n) === i);
        this.productionline = productlineArray.filter((n, i) => productlineArray.indexOf(n) === i);
        this.defectModeAggregation = defectModeAggregationArray.filter((n, i) => defectModeAggregationArray.indexOf(n) === i);
        this.defectModeAggregationdefault = this.defectModeAggregation;
        // this.productdefault = this.product;
        this.recordiddefault = this.recordid;
        this.productlinedefault = this.productionline;
        this.pdcastatusdefault = this.pdcastatus;
        this.allDefectModeAggregationSelected = true;
        this.allProductSelected = true;
        this.allProductLineSelected = true;
        this.allPDCASelected = true;
        this.nofiltereddata = false;
      }
    }
  }

  filterDataForCharts() {
    const selectedFromDate = this.datepipe.transform(this.qamatrixDashboardForm.get('fromdate').value, 'MM/dd/yyyy');
    const selectedTodate = this.datepipe.transform(this.qamatrixDashboardForm.get('todate').value, 'MM/dd/yyyy');
    const selectedcluster = this.qamatrixDashboardForm.get('clusters').value;
    const selectedsite = this.qamatrixDashboardForm.get('sites').value;
    const selectedbigcategory = this.qamatrixDashboardForm.get('bigcategories').value;
    const selecteddefectModeAggregation = this.qamatrixDefects.get('DefectModeAggregationControl').value;
    const selectedproduct = this.qamatrixDefects.get('productcontrol').value;
    const selectedproductline = this.qamatrixDefects.get('ProductLineControl').value;
    const selectedPDCAStatus = this.qamatrixDefects.get('PDCAStatusControl').value;
    if ((selecteddefectModeAggregation != null && selecteddefectModeAggregation.length > 0)
      || (selectedproduct !== null && selectedproduct.length > 0)
      || (selectedproductline !== null && selectedproductline.length > 0)
      || (selectedPDCAStatus !== null && selectedPDCAStatus.length > 0)) {
      this.chartsFilterParameter = {
        fromDate: selectedFromDate,
        toDate: selectedTodate,
        bigcategory: selectedbigcategory,
        cluster: selectedcluster,
        site: selectedsite,
        dpidefectclass: this.defectClassSelect[0] === this.dpiDefectClassSelectControlValue ? this.defectClassSelect : [this.dpiDefectClassSelectControlValue],
        defectseverity: this.severitySelect[0] === this.defectSeveritySelectControlValue ? this.severitySelect : [this.defectSeveritySelectControlValue],
        defectmodeaggregation: selecteddefectModeAggregation,
        product: selectedproduct,
        productionline: selectedproductline,
        pdcastatus: selectedPDCAStatus
      };
      this.getDashboardChartsSQLData(this.chartsFilterParameter);
    }
  }

  filterDataForPareto() {
    const selectedFromDate = this.datepipe.transform(this.qamatrixDashboardForm.get('fromdate').value, 'MM/dd/yyyy');
    const selectedTodate = this.datepipe.transform(this.qamatrixDashboardForm.get('todate').value, 'MM/dd/yyyy');
    const selectedcluster = this.qamatrixDashboardForm.get('clusters').value;
    const selectedsite = this.seletedTab === this.dashboardTabs[1]
                          ? this.qamatrixDefectsParetoForm.get('sites').value
                          : this.qamatrixParetoForm.get('sites').value;
    const selectedbigcategory = this.seletedTab === this.dashboardTabs[1]
                                ? this.qamatrixDefectsParetoForm.get('bigcategories').value
                                : this.qamatrixParetoForm.get('bigcategories').value;
    const selecteddpidefectclass = this.seletedTab === this.dashboardTabs[1]
                                    ? this.qamatrixDefectsParetoForm.get('dpiDefectClassSelectControl').value
                                    : this.qamatrixParetoForm.get('dpiDefectClassSelectControl').value;
    const selecteddefectseverity = this.seletedTab === this.dashboardTabs[1]
                                    ? this.qamatrixDefectsParetoForm.get('defectSeveritySelectControl').value
                                    : this.qamatrixParetoForm.get('defectSeveritySelectControl').value;
    this.paretoFilterParameter = {
      fromDate: selectedFromDate,
      toDate: selectedTodate,
      bigcategory: selectedbigcategory,
      cluster: selectedcluster,
      site: selectedsite,
      dpidefectclass: this.defectClassSelect[0] === selecteddpidefectclass ? this.defectClassSelect : [selecteddpidefectclass],
      defectseverity: this.severitySelect[0] === selecteddefectseverity ? this.severitySelect : [selecteddefectseverity]
    };
    if (this.seletedTab === this.dashboardTabs[2]) {
      this.processParetoReportArray = [];
      this.getProcessParetoReportData(this.paretoFilterParameter);
    } else if (this.seletedTab === this.dashboardTabs[1]) {
      this.paretoReportArray = [];
      this.getParetoReportData(this.paretoFilterParameter);
    }
  }

  getClusterSiteBigCategoryData() {

    this.dashboardService.getClusterFactoryData().subscribe((response) => {
      if (response.length === 0) {
        this.ValidationMsg = 'Failed to get the Sub Region, site and Business Group. Please try again after sometime.';
        this.showValidationMessage = true;
        this.loading = false;
      } else {
        // this.noRecordsShow = false;
        // const UpdatedResponse = [];
        response.forEach((e) => {
          let object: ClusterSiteBigCategoryData;
          object = {
            subregion: e.subregion,
            site: e.site,
            businessgroup: e.businessgroup,
            factoryname: e.factoryname
          };
          this.clustersitebigcategoryArray.push(object);
        });
        this.cluster = this.clustersitebigcategoryArray.map(item => item.subregion).filter((value, index, self) => self.indexOf(value) === index).sort();
        this.selectClusterSiteDropdownwithdefault();
        // this.loading = false;
      }
    }, (error) => {
      this.ValidationMsg = 'Failed to get the cluster, site and Bigcategory. Please try again after sometime.';
      this.showValidationMessage = true;
      this.loading = false;
    });
  }

  loadSite() {
    this.loading = true;
    this.bigcategory = [];
    this.site = [];
    const tempArray: string[] = [];
    this.clustertooltip = [];
    this.sitetooltip = [];
    this.bigcategorytooltip = [];
    this.qamatrixDashboardForm.get('sites').setValue(null);
    let clusterSelected = [];
    if (this.qamatrixDashboardForm.get('clusters').value !== null && this.qamatrixDashboardForm.get('clusters').value.length > 0) {
      clusterSelected = this.qamatrixDashboardForm.get('clusters').value;
      this.clustertooltip = clusterSelected;
      let clusterAll = true;
      this.clusterControl.options.forEach((item: MatOption) => {
        if (!item.selected) {
          clusterAll = false;
        }
      });
      this.allSelected = clusterAll;
      clusterSelected.forEach(clusterelement => {
        this.clustersitebigcategoryArray.forEach(element => {
          if (clusterelement === element.subregion) {
            tempArray.push(element.site);
          }
        });
      });
      this.site = tempArray.map(item => item).filter((value, index, self) => self.indexOf(value) === index).sort();
      this.sitedefault = this.site;
      this.sitetooltip = this.sitedefault;
      setTimeout(() => {
        this.loadBigCategory();
      }, 2000);
    } else {
      this.loading = false;
    }
    this.showValidationMessage = false;
    this.showSuccess = false;
    this.dataAvailable = false;
    this.noRecords = '';
    this.nofiltereddata = true;
  }

  loadBigCategory() {
    this.bigcategory = [];
    this.qamatrixDashboardForm.get('bigcategories').setValue(null);
    this.sitetooltip = [];
    this.bigcategorytooltip = [];
    let siteSelected = [];
    const tempBigCategoryArray: string[] = [];
    if (this.qamatrixDashboardForm.get('sites').value !== null && this.qamatrixDashboardForm.get('sites').value.length > 0) {
      siteSelected = this.qamatrixDashboardForm.get('sites').value;
      this.sitetooltip = siteSelected;
      siteSelected.forEach(siteelement => {
        this.clustersitebigcategoryArray.forEach(element => {
          if (siteelement === element.site) {
            tempBigCategoryArray.push(element.businessgroup);
          }
        });
      });
      this.bigcategory = tempBigCategoryArray.map(item => item).filter((value, index, self) => self.indexOf(value) === index).sort();
      this.bigcategorydefault = this.bigcategory;
      this.bigcategorytooltip = this.bigcategorydefault;
      let siteAll = true;
      this.siteControl.options.forEach((item: MatOption) => {
        if (!item.selected) {
          siteAll = false;
        }
      });
      this.siteAllSelected = siteAll;

      let bigCategoryAll = true;
      this.bigCategoryControl.options.forEach((item: MatOption) => {
        if (!item.selected) {
          bigCategoryAll = false;
        }
      });
      this.bigCategoryAllSelected = bigCategoryAll;
      this.showValidationMessage = false;
      this.showSuccess = false;
      this.dataAvailable = false;
      this.noRecords = '';
      this.nofiltereddata = true;
      this.loading = false;
    }
  }

  assignTooltip() {
    this.bigcategorytooltip = [];
    this.bigcategorytooltip = this.qamatrixDashboardForm.get('bigcategories').value;
    this.showValidationMessage = false;
    this.showSuccess = false;
    this.dataAvailable = false;
    this.noRecords = '';
    this.nofiltereddata = true;
  }

  // Authorization
  get isAuthorized() {
    this.role = localStorage.getItem('role');
    if (this.role === Role.globalAdmin) {
      return true;
    } else {
      return false;
    }
  }

  exportExcel() {
    this.excelService.generateExcel(this.filteredDataSource);
  }

  saveAgreement() {
    const fromDateyear = new Date(this.filterParameter.fromDate).getFullYear();
    const fromDateVal = new Date(this.filterParameter.fromDate);
    const toDateVal = new Date(this.filterParameter.toDate);
    const startDate = new Date('01/01/' + fromDateyear);
    const todayDate = new Date();
    // const Q1Validation = new Date('03/31/' + fromDateyear);
    const H1Validation = new Date('06/30/' + fromDateyear);
    // const Q3Validation = new Date('09/30/' + fromDateyear);
    const H2Validation = new Date('12/31/' + fromDateyear);
    const H1BetweenFromDate = new Date('07/01/' + fromDateyear);
    const H1BetweenToDate = new Date('12/31/' + fromDateyear);
    const H2BetweenFromDate = new Date('01/01/' + (fromDateyear + 1));
    const H2BetweenToDate = new Date('06/30/' + (fromDateyear + 1));
    if ((fromDateVal.toDateString() === startDate.toDateString() || fromDateVal.toDateString() === H1BetweenFromDate.toDateString())
        && (toDateVal.toDateString() === H1Validation.toDateString() && H1BetweenFromDate <= todayDate && H1BetweenToDate >= todayDate)
        || (toDateVal.toDateString() === H2Validation.toDateString() && H2BetweenFromDate <= todayDate && H2BetweenToDate >= todayDate)
        && this.filterParameter.cluster.length === 1 && this.filterParameter.site.length === 1 && this.filterParameter.bigcategory.length === 1) {
      const pivotData: PivotTableAgreement = {
        fromDate: this.filterParameter.fromDate,
        toDate: this.filterParameter.toDate,
        cluster: this.filterParameter.cluster,
        site: this.filterParameter.site,
        bigcategory: this.filterParameter.bigcategory,
        dataDetails: this.filteredDataSource
      };
      this.showValidationMessage = false;
      this.showSuccess = false;
      this.dashboardService.insertAgreementDetails(pivotData).subscribe((response) => {
        if (response !== null) {
          this.recordInserted = response.totalRowsInserted;
          this.recordUpdated = response.duplicateRows;

          this.recordsinserteddetails = 'Number of records inserted: ' + this.recordInserted;
          // this.recordupdateddetails = 'Number of records updated: ' + this.recordUpdated;
          this.showSuccess = true;
          setTimeout(() => {
            this.showSuccess = false;
          }, 30000);
        } else {
          this.ValidationMsg = 'Insert / Update Agreement details failed.';
          this.showValidationMessage = true;
        }
      }, (error) => {
        if (error.error !== '') {
          this.ValidationMsg = error.error;
        } else {
          this.ValidationMsg = 'Insert / Update Agreement details failed.. Please try again after sometime.';
        }
        this.showValidationMessage = true;
        this.loading = false;
      });
    } else {
      this.ValidationMsg = 'From Date and To date should be selected H1 or H2 only. And only one cluster, site and big category should be selected to save the pivot table details.';
      this.showValidationMessage = true;
      this.loading = false;
    }
    setTimeout(() => {
      this.showValidationMessage = false;
    }, 30000);
  }

  onTabClick(event: any) {
    this.dataAvailable = false;
    this.loading = true;
    this.seletedTab = event.tab.textLabel;
    if (this.seletedTab === this.dashboardTabs[1] || this.seletedTab === this.dashboardTabs[2]) {
      this.setDpiDefectClassSelect();
      this.setDefectSeveritySelect();
    }
    this.generateReport();
  }

  getProcessParetoReportData(filterParameter: IncidentsDashboardParetoViewModel) {
    this.dashboardService.getProcessParetoReportData(filterParameter).subscribe(response => {
      const processParetoArray = [];
      response.paretoReport.forEach(e => {
        let object = {};
        object = {
          processpoint: e.processpoint,
          defectpriorityindex: e.defectpriorityindex
        };
        processParetoArray.push(object);
      });
      this.processParetoReportArray = processParetoArray;
      this.loading = false;
      this.showtabs = true;
      this.showProcessPareto = true;
    });
  }

  getParetoReportData(filterParameter: IncidentsDashboardParetoViewModel) {
    this.dashboardService.getParetoReportData(filterParameter).subscribe(response => {
      const paretoArray = [];
      response.paretoReport.forEach(e => {
        let object = {};
        object = {
          defectmodeaggregation: e.defectmodeaggregation,
          defectpriorityindex: e.defectpriorityindex
        };
        paretoArray.push(object);
      });
      this.paretoReportArray = paretoArray;
      this.loading = false;
      this.showtabs = true;
      this.showPareto = true;
    });
  }
}
